import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';

const PrivacyPolicy = () => {
  const styles = {
    navbar: {
      backgroundColor: '#667eea',
      padding: '1rem 0',
      marginBottom: '0',
    },
    navbarBrand: {
      color: '#ffffff',
      fontSize: '24px',
      fontWeight: 'bold',
      textDecoration: 'none',
    },
    hero: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '60px 0',
      marginBottom: '0',
    },
    heroTitle: {
      fontSize: '42px',
      fontWeight: 'bold',
      marginBottom: '15px',
      textAlign: 'center',
    },
    heroSubtitle: {
      fontSize: '18px',
      textAlign: 'center',
      opacity: '0.95',
    },
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      lineHeight: '1.8',
      backgroundColor: '#ffffff',
    },
    section: {
      marginBottom: '35px',
      padding: '25px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      border: '1px solid #e9ecef',
    },
    sectionTitle: {
      fontSize: '22px',
      fontWeight: '600',
      marginBottom: '15px',
      color: '#667eea',
      borderBottom: '2px solid #667eea',
      paddingBottom: '10px',
    },
    subsectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      marginTop: '20px',
      marginBottom: '10px',
      color: '#495057',
    },
    paragraph: {
      marginBottom: '15px',
      color: '#495057',
      fontSize: '15px',
    },
    list: {
      marginLeft: '20px',
      listStyleType: 'disc',
      color: '#495057',
    },
    listItem: {
      marginBottom: '8px',
      fontSize: '15px',
    },
    important: {
      backgroundColor: '#e7f3ff',
      border: '1px solid #2196f3',
      borderRadius: '8px',
      padding: '15px',
      marginTop: '15px',
      marginBottom: '15px',
    },
    importantIcon: {
      color: '#2196f3',
      fontSize: '20px',
      marginRight: '10px',
    },
    footer: {
      textAlign: 'center',
      marginTop: '40px',
      padding: '30px 20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '12px',
      fontSize: '14px',
      color: '#6c757d',
    },
    contactInfo: {
      backgroundColor: '#e7f1ff',
      padding: '20px',
      borderRadius: '8px',
      marginTop: '20px',
      border: '1px solid #b8daff',
    },
  };

  return (
    <>
      {/* Navbar */}
      <Navbar style={styles.navbar} expand="lg">
        <Container>
          <Navbar.Brand href="/" style={styles.navbarBrand}>
            Tasacionesya.com
          </Navbar.Brand>
          <Nav className="ms-auto">
            <Nav.Link href="/" style={{ color: 'white' }}>Inicio</Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <div style={styles.hero}>
        <Container>
          <h1 style={styles.heroTitle}>Política de Privacidad</h1>
          <p style={styles.heroSubtitle}>Protección y tratamiento de tus datos personales</p>
          <p style={styles.heroSubtitle}>Última actualización: 16 de enero de 2026</p>
        </Container>
      </div>

      {/* Content */}
      <div style={styles.container}>
        {/* Introduction */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Introducción</h2>
          <p style={styles.paragraph}>
            En <strong>Tasacionesya.com</strong>, operado por <strong>Sr Realty Group S.A.S.</strong>, nos comprometemos 
            a proteger tu privacidad y tus datos personales. Esta Política de Privacidad describe cómo recopilamos, 
            usamos, almacenamos y protegemos tu información personal.
          </p>
          <p style={styles.paragraph}>
            Al utilizar nuestros servicios, incluidas las valuaciones de propiedades, aceptas las prácticas descritas 
            en esta política. Te recomendamos leer este documento detenidamente para comprender cómo manejamos tu información.
          </p>
          <p style={styles.paragraph}>
            Esta política cumple con la <strong>Ley 25.326 de Protección de Datos Personales de Argentina</strong> y 
            sus normas complementarias.
          </p>
        </div>

        {/* Responsable del Tratamiento */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Responsable del Tratamiento de Datos</h2>
          <div style={styles.contactInfo}>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Razón Social:</strong> Sr Realty Group S.A.S.
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Domicilio:</strong> Buenos Aires, Argentina
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Email:</strong> <a href="mailto:info@tasacionesya.com" style={{ color: '#667eea' }}>info@tasacionesya.com</a>
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Sitio web:</strong> <a href="https://tasacionesya.com" style={{ color: '#667eea' }}>www.tasacionesya.com</a>
            </p>
          </div>
        </div>

        {/* Data Collection */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Información que Recopilamos</h2>
          
          <h3 style={styles.subsectionTitle}>3.1 Datos Proporcionados Directamente por Ti</h3>
          <p style={styles.paragraph}>Cuando utilizas nuestros servicios, recopilamos:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Información de contacto:</strong> Nombre completo, número de teléfono, dirección de correo electrónico
            </li>
            <li style={styles.listItem}>
              <strong>Credenciales de cuenta:</strong> Contraseña (almacenada de forma hasheada con bcrypt y salt, nunca 
              en texto plano)
            </li>
            <li style={styles.listItem}>
              <strong>Tipo de usuario:</strong> Personal, Corporativo, o Agente Inmobiliario
            </li>
            <li style={styles.listItem}>
              <strong>Información de la propiedad:</strong> Dirección completa, tipo de propiedad (casa, departamento, etc.), 
              características (ambientes, superficie, antigüedad, amenities)
            </li>
            <li style={styles.listItem}>
              <strong>Información de la operación:</strong> Tipo de operación (venta o alquiler), motivo de la valuación, 
              valor estimado esperado
            </li>
            <li style={styles.listItem}>
              <strong>Información empresarial:</strong> Nombre de empresa, CUIT/CUIL (para usuarios corporativos o agentes)
            </li>
            <li style={styles.listItem}>
              <strong>Datos de pago:</strong> Información procesada por MercadoPago (no almacenamos datos de tarjetas)
            </li>
            <li style={styles.listItem}>
              <strong>Códigos promocionales:</strong> Códigos de descuento o gratuitos utilizados
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>3.2 Datos Recopilados Automáticamente</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Información técnica:</strong> Dirección IP, tipo de navegador, sistema operativo, proveedor de internet
            </li>
            <li style={styles.listItem}>
              <strong>Datos de navegación:</strong> Páginas visitadas, tiempo de permanencia, referencia de origen (cómo llegaste a nuestro sitio)
            </li>
            <li style={styles.listItem}>
              <strong>Cookies y tecnologías similares:</strong> Identificadores únicos, preferencias del usuario
            </li>
            <li style={styles.listItem}>
              <strong>Información de dispositivo:</strong> Modelo de dispositivo, resolución de pantalla, idioma configurado
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>3.3 Datos de Fuentes de Marketing</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Parámetros UTM:</strong> Información sobre campañas publicitarias (Google Ads, TikTok Ads, Facebook Ads)
            </li>
            <li style={styles.listItem}>
              <strong>Referencias:</strong> Sitios web desde donde nos visitaste
            </li>
            <li style={styles.listItem}>
              <strong>ID de visitante:</strong> Identificador único para seguimiento de conversiones
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>3.4 Datos Específicos de Cuentas de Agente</h3>
          <p style={styles.paragraph}>
            Para usuarios registrados como Agentes Inmobiliarios, adicionalmente recopilamos y procesamos:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Créditos premium:</strong> Cantidad de créditos gratuitos disponibles (otorgados al registro) y utilizados
            </li>
            <li style={styles.listItem}>
              <strong>Historial de valuaciones:</strong> Registro completo de todas las valuaciones realizadas, incluyendo:
              <ul style={{ ...styles.list, marginTop: '8px' }}>
                <li style={styles.listItem}>Fecha y hora de cada valuación</li>
                <li style={styles.listItem}>Tipo de valuación (gratuita con crédito o premium pagada)</li>
                <li style={styles.listItem}>Propiedades valuadas (dirección, características)</li>
                <li style={styles.listItem}>Estado de visibilidad (visible u oculta por el usuario)</li>
              </ul>
            </li>
            <li style={styles.listItem}>
              <strong>Estadísticas de uso:</strong> Total de valuaciones, valuaciones premium, valuaciones con créditos gratuitos
            </li>
            <li style={styles.listItem}>
              <strong>Fecha de registro:</strong> Fecha de creación de la cuenta de agente
            </li>
            <li style={styles.listItem}>
              <strong>Información de cuenta:</strong> Estado de cuenta (activa o eliminada)
            </li>
          </ul>
        </div>

        {/* How We Use Data */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Cómo Utilizamos tu Información</h2>
          
          <div style={styles.important}>
            <span style={styles.importantIcon}>📱</span>
            <strong>IMPORTANTE - Consentimiento de Contacto Comercial:</strong> Al solicitar una valuación o utilizar 
            nuestros servicios, otorgas tu consentimiento expreso e informado para que te contactemos con fines 
            comerciales y de marketing.
          </div>

          <h3 style={styles.subsectionTitle}>4.1 Prestación de Servicios</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Procesar y generar valuaciones de propiedades</li>
            <li style={styles.listItem}>Enviar resultados de valuaciones por email o WhatsApp</li>
            <li style={styles.listItem}>Gestionar tu cuenta de usuario, contraseña y preferencias</li>
            <li style={styles.listItem}>Administrar créditos premium para cuentas de agente</li>
            <li style={styles.listItem}>Validar y aplicar códigos promocionales (descuentos o gratuitos)</li>
            <li style={styles.listItem}>Mantener historial de valuaciones para usuarios registrados</li>
            <li style={styles.listItem}>Procesar pagos por servicios premium a través de MercadoPago</li>
            <li style={styles.listItem}>Brindar soporte técnico y atención al cliente</li>
            <li style={styles.listItem}>Generar estadísticas de uso para cuentas de agente</li>
          </ul>

          <h3 style={styles.subsectionTitle}>4.2 Comunicaciones Comerciales y Marketing</h3>
          <p style={styles.paragraph}>
            <strong>Usamos tu número de teléfono y correo electrónico para:</strong>
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Contactarte comercialmente</strong> para ofrecerte nuestros servicios inmobiliarios, incluyendo:
              <ul style={{ ...styles.list, marginTop: '8px' }}>
                <li style={styles.listItem}>Servicios de venta de propiedades</li>
                <li style={styles.listItem}>Servicios de alquiler y administración</li>
                <li style={styles.listItem}>Valuaciones profesionales y peritajes oficiales</li>
                <li style={styles.listItem}>Asesoramiento inmobiliario personalizado</li>
                <li style={styles.listItem}>Financiación y créditos hipotecarios</li>
              </ul>
            </li>
            <li style={styles.listItem}>
              Enviarte promociones, ofertas especiales y descuentos en nuestros servicios
            </li>
            <li style={styles.listItem}>
              Compartir contenido informativo sobre el mercado inmobiliario (newsletters, informes de mercado)
            </li>
            <li style={styles.listItem}>
              Realizar seguimiento comercial sobre tu valuación y necesidades inmobiliarias
            </li>
            <li style={styles.listItem}>
              Invitarte a eventos, webinars y presentaciones inmobiliarias
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>4.3 WhatsApp Business API</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>💬</span>
            Utilizamos <strong>WhatsApp Cloud API (Meta)</strong> para:
          </div>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Verificación de números:</strong> Validar tu número de teléfono mediante códigos OTP (One-Time Password)
            </li>
            <li style={styles.listItem}>
              <strong>Envío de valuaciones:</strong> Enviarte los resultados de tu valuación directamente por WhatsApp
            </li>
            <li style={styles.listItem}>
              <strong>Comunicaciones comerciales:</strong> Contactarte con ofertas y seguimiento de servicios
            </li>
            <li style={styles.listItem}>
              <strong>Atención al cliente:</strong> Responder consultas y brindar soporte
            </li>
            <li style={styles.listItem}>
              <strong>Notificaciones importantes:</strong> Avisos sobre el estado de tus solicitudes
            </li>
          </ul>
          <p style={styles.paragraph}>
            Al proporcionar tu número de teléfono, aceptas recibir mensajes de WhatsApp de nuestra parte. 
            Los mensajes están sujetos a las políticas de WhatsApp y Meta.
          </p>

          <h3 style={styles.subsectionTitle}>4.4 Mejora de Servicios y Análisis</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Analizar el uso de la plataforma para mejorar la experiencia del usuario</li>
            <li style={styles.listItem}>Realizar análisis estadísticos y estudios de mercado</li>
            <li style={styles.listItem}>Optimizar nuestros algoritmos de valuación</li>
            <li style={styles.listItem}>Medir la efectividad de campañas publicitarias</li>
            <li style={styles.listItem}>Detectar y prevenir fraudes o uso indebido de la plataforma</li>
          </ul>

          <h3 style={styles.subsectionTitle}>4.5 Cumplimiento Legal</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Cumplir con obligaciones legales y regulatorias</li>
            <li style={styles.listItem}>Responder a requerimientos judiciales o de autoridades competentes</li>
            <li style={styles.listItem}>Proteger nuestros derechos legales y hacer cumplir nuestros términos de servicio</li>
          </ul>
        </div>

        {/* Base Legal */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Base Legal del Tratamiento</h2>
          <p style={styles.paragraph}>Tratamos tus datos personales en base a:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Consentimiento:</strong> Al utilizar nuestros servicios y solicitar valuaciones, otorgas tu 
              consentimiento expreso para el tratamiento de tus datos con los fines descritos, incluyendo el 
              contacto comercial y de marketing.
            </li>
            <li style={styles.listItem}>
              <strong>Ejecución contractual:</strong> Para poder prestarte los servicios que solicitas (valuaciones, 
              gestión de cuenta, etc.).
            </li>
            <li style={styles.listItem}>
              <strong>Interés legítimo:</strong> Para mejorar nuestros servicios, realizar análisis de mercado y 
              prevenir fraudes.
            </li>
            <li style={styles.listItem}>
              <strong>Obligación legal:</strong> Para cumplir con leyes y regulaciones aplicables.
            </li>
          </ul>
        </div>

        {/* Data Sharing */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Compartir Información con Terceros</h2>
          
          <h3 style={styles.subsectionTitle}>6.1 Servicios de Terceros</h3>
          <p style={styles.paragraph}>Compartimos tu información con proveedores de servicios esenciales:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>MercadoPago:</strong> Para procesar pagos de forma segura
            </li>
            <li style={styles.listItem}>
              <strong>Meta (WhatsApp Cloud API):</strong> Para envío de mensajes de verificación y comunicaciones
            </li>
            <li style={styles.listItem}>
              <strong>Servicios de hosting:</strong> Para almacenar datos en servidores seguros
            </li>
            <li style={styles.listItem}>
              <strong>Servicios de email:</strong> Para envío de notificaciones y comunicaciones (ZeptoMail)
            </li>
            <li style={styles.listItem}>
              <strong>Herramientas de análisis:</strong> Para mejorar nuestros servicios (Google Analytics, si aplica)
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>6.2 No Vendemos tu Información</h3>
          <p style={styles.paragraph}>
            <strong>Nunca vendemos, alquilamos ni comercializamos</strong> tus datos personales a terceros con fines 
            de marketing ajenos a nuestros servicios inmobiliarios.
          </p>

          <h3 style={styles.subsectionTitle}>6.3 Divulgaciones Legales</h3>
          <p style={styles.paragraph}>
            Podemos divulgar tu información si es requerido por ley, orden judicial, o para proteger nuestros 
            derechos legales y la seguridad de nuestros usuarios.
          </p>
        </div>

        {/* Cookies */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Cookies y Tecnologías de Seguimiento</h2>
          
          <h3 style={styles.subsectionTitle}>7.1 Qué son las Cookies</h3>
          <p style={styles.paragraph}>
            Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas nuestro sitio web. 
            Utilizamos cookies para mejorar tu experiencia y analizar el uso de la plataforma.
          </p>

          <h3 style={styles.subsectionTitle}>7.2 Tipos de Cookies que Utilizamos</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Cookies esenciales:</strong> Necesarias para el funcionamiento básico del sitio (sesión de usuario, 
              seguridad)
            </li>
            <li style={styles.listItem}>
              <strong>Cookies de rendimiento:</strong> Para analizar cómo los usuarios utilizan el sitio y mejorar 
              la experiencia
            </li>
            <li style={styles.listItem}>
              <strong>Cookies de marketing:</strong> Para medir la efectividad de campañas publicitarias y mostrar 
              anuncios relevantes
            </li>
            <li style={styles.listItem}>
              <strong>Cookies de terceros:</strong> De servicios como Google Analytics, MercadoPago y plataformas 
              publicitarias
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>7.3 Gestión de Cookies</h3>
          <p style={styles.paragraph}>
            Puedes configurar tu navegador para rechazar cookies o avisarte cuando se envíen. Sin embargo, algunas 
            funciones del sitio pueden no funcionar correctamente sin cookies esenciales.
          </p>
        </div>

        {/* Data Security */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Seguridad de los Datos</h2>
          <p style={styles.paragraph}>
            Implementamos medidas técnicas y organizativas apropiadas para proteger tu información personal contra 
            acceso no autorizado, pérdida, destrucción o alteración:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Encriptación de contraseñas:</strong> Utilizamos el algoritmo bcrypt con salt para hashear 
              contraseñas. Esto significa que:
              <ul style={{ ...styles.list, marginTop: '8px' }}>
                <li style={styles.listItem}>Tu contraseña nunca se almacena en texto plano</li>
                <li style={styles.listItem}>Es computacionalmente inviable recuperar la contraseña original del hash</li>
                <li style={styles.listItem}>Cada contraseña tiene un salt único para prevenir ataques de tablas rainbow</li>
                <li style={styles.listItem}>Ni siquiera los administradores pueden ver tu contraseña</li>
              </ul>
            </li>
            <li style={styles.listItem}>
              <strong>Encriptación en tránsito:</strong> Conexiones HTTPS seguras para proteger datos en tránsito
            </li>
            <li style={styles.listItem}>
              <strong>Bases de datos seguras:</strong> Almacenamiento en MongoDB con autenticación, contraseña y 
              acceso restringido por IP
            </li>
            <li style={styles.listItem}>
              <strong>Autenticación:</strong> Sistema de tokens (JWT-like) con codificación base64 para sesiones de usuario
            </li>
            <li style={styles.listItem}>
              <strong>Monitoreo:</strong> Registro y monitoreo de accesos a datos sensibles y acciones administrativas
            </li>
            <li style={styles.listItem}>
              <strong>Actualizaciones:</strong> Mantenimiento regular de sistemas de seguridad y dependencias
            </li>
            <li style={styles.listItem}>
              <strong>Separación de privilegios:</strong> Diferentes niveles de acceso para usuarios, agentes y administradores
            </li>
          </ul>
          <p style={styles.paragraph}>
            Sin embargo, ningún método de transmisión por internet o almacenamiento electrónico es 100% seguro. 
            Si bien nos esforzamos por proteger tu información, no podemos garantizar su seguridad absoluta. 
            Te recomendamos:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Utilizar una contraseña fuerte y única</li>
            <li style={styles.listItem}>No compartir tus credenciales con terceros</li>
            <li style={styles.listItem}>Cerrar sesión al terminar de usar la plataforma en dispositivos compartidos</li>
            <li style={styles.listItem}>Notificarnos inmediatamente si sospechas un acceso no autorizado</li>
          </ul>
        </div>

        {/* Data Retention */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Conservación y Gestión de Datos</h2>
          
          <h3 style={styles.subsectionTitle}>9.1 Períodos de Retención</h3>
          <p style={styles.paragraph}>
            Conservamos tu información personal durante el tiempo necesario para:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              Proporcionar nuestros servicios y mantener tu historial de valuaciones
            </li>
            <li style={styles.listItem}>
              Cumplir con obligaciones legales, fiscales y contables (mínimo 5 años según normativa argentina)
            </li>
            <li style={styles.listItem}>
              Resolver disputas y hacer cumplir nuestros acuerdos
            </li>
            <li style={styles.listItem}>
              Fines de marketing, hasta que solicites la baja de comunicaciones
            </li>
            <li style={styles.listItem}>
              Mantener estadísticas agregadas y anónimas para análisis de mercado
            </li>
          </ul>
          <p style={styles.paragraph}>
            Cuando ya no necesitemos conservar tu información, la eliminaremos de forma segura o la anonimizaremos 
            para que no pueda identificarte.
          </p>

          <h3 style={styles.subsectionTitle}>9.2 Gestión de Historial (Cuentas de Agente)</h3>
          <p style={styles.paragraph}>
            Los usuarios con cuenta de agente pueden gestionar la visibilidad de su historial de valuaciones:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Ocultación temporal:</strong> Los agentes pueden ocultar valuaciones específicas de su vista personal. 
              Las valuaciones ocultas:
              <ul style={{ ...styles.list, marginTop: '8px' }}>
                <li style={styles.listItem}>No aparecen en el panel del agente</li>
                <li style={styles.listItem}>Permanecen en el sistema para fines administrativos y contables</li>
                <li style={styles.listItem}>Siguen siendo accesibles para el equipo administrativo</li>
                <li style={styles.listItem}>Se conservan según los períodos de retención legales</li>
              </ul>
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>9.3 Eliminación de Cuenta</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>🗑️</span>
            <strong>Derecho de Supresión:</strong> Puedes solicitar la eliminación completa de tu cuenta en cualquier 
            momento desde la sección "Mi Cuenta" de tu perfil.
          </div>
          <p style={styles.paragraph}>
            Cuando eliminas tu cuenta:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Soft Delete:</strong> Tu cuenta se marca como "eliminada" y tu email se modifica para prevenir 
              reutilización (formato: deleted_[userID]_[email_original])
            </li>
            <li style={styles.listItem}>
              <strong>Acceso bloqueado:</strong> No podrás volver a iniciar sesión ni acceder a tu cuenta
            </li>
            <li style={styles.listItem}>
              <strong>Datos personales:</strong> Tu información de contacto queda inaccesible para fines de marketing
            </li>
            <li style={styles.listItem}>
              <strong>Conservación legal:</strong> Ciertos datos (transacciones, valuaciones, información fiscal) 
              se conservan por el período legal requerido (5-10 años según aplique)
            </li>
            <li style={styles.listItem}>
              <strong>Irreversible:</strong> La eliminación es permanente y no puedes recuperar tu cuenta
            </li>
          </ul>
          <div style={styles.important}>
            <span style={styles.importantIcon}>⚠️</span>
            <strong>IMPORTANTE:</strong> Antes de eliminar tu cuenta, asegúrate de descargar o guardar cualquier 
            información que desees conservar, como tu historial de valuaciones.
          </div>
        </div>

        {/* User Rights */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>10. Tus Derechos como Usuario</h2>
          <p style={styles.paragraph}>
            De acuerdo con la <strong>Ley 25.326 de Protección de Datos Personales de Argentina</strong>, tienes 
            los siguientes derechos:
          </p>

          <h3 style={styles.subsectionTitle}>10.1 Derecho de Acceso</h3>
          <p style={styles.paragraph}>
            Puedes solicitar información sobre qué datos personales tenemos sobre ti y cómo los utilizamos.
          </p>

          <h3 style={styles.subsectionTitle}>10.2 Derecho de Rectificación</h3>
          <p style={styles.paragraph}>
            Puedes solicitar la corrección de datos inexactos o incompletos.
          </p>

          <h3 style={styles.subsectionTitle}>10.3 Derecho de Supresión (Eliminación de Cuenta)</h3>
          <p style={styles.paragraph}>
            Puedes solicitar la eliminación completa de tu cuenta y datos personales mediante:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Autogestión:</strong> Desde la sección "Mi Cuenta" en tu perfil, utilizando el botón "Eliminar Mi Cuenta"
            </li>
            <li style={styles.listItem}>
              <strong>Solicitud por email:</strong> Escribiendo a info@tasacionesya.com con el asunto "Eliminación de Cuenta"
            </li>
          </ul>
          <p style={styles.paragraph}>
            Ten en cuenta que ciertos datos pueden conservarse por obligaciones legales, contables o fiscales, 
            pero quedarán disociados de tu identidad personal.
          </p>

          <h3 style={styles.subsectionTitle}>10.4 Derecho de Portabilidad</h3>
          <p style={styles.paragraph}>
            Los usuarios con cuenta de agente pueden exportar su historial de valuaciones y estadísticas. 
            Para solicitar una copia de tus datos en formato estructurado, contáctanos.
          </p>

          <h3 style={styles.subsectionTitle}>10.5 Derecho de Oposición</h3>
          <p style={styles.paragraph}>
            Puedes oponerte al tratamiento de tus datos para fines de marketing directo en cualquier momento.
          </p>

          <h3 style={styles.subsectionTitle}>10.6 Derecho a Ocultar Historial (Agentes)</h3>
          <p style={styles.paragraph}>
            Los usuarios con cuenta de agente pueden ocultar valuaciones específicas de su vista personal sin 
            eliminarlas del sistema. Esta funcionalidad está disponible directamente en el panel de "Valuaciones".
          </p>

          <h3 style={styles.subsectionTitle}>10.7 Baja de Comunicaciones Comerciales</h3>
          <div style={styles.important}>
            <span style={styles.importantIcon}>✉️</span>
            Para dejar de recibir comunicaciones de marketing, puedes:
          </div>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              Enviarnos un email a <strong>info@tasacionesya.com</strong> con el asunto "Baja de comunicaciones"
            </li>
            <li style={styles.listItem}>
              Hacer clic en el enlace de "Cancelar suscripción" en nuestros emails
            </li>
            <li style={styles.listItem}>
              Responder "BAJA" a nuestros mensajes de WhatsApp
            </li>
          </ul>

          <h3 style={styles.subsectionTitle}>10.8 Cómo Ejercer tus Derechos</h3>
          <p style={styles.paragraph}>
            Para ejercer cualquiera de estos derechos, contáctanos a:
          </p>
          <div style={styles.contactInfo}>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Email:</strong> <a href="mailto:info@tasacionesya.com" style={{ color: '#667eea' }}>info@tasacionesya.com</a>
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Asunto:</strong> "Ejercicio de Derechos ARCO - [Tu nombre]"
            </p>
          </div>
          <p style={styles.paragraph}>
            Responderemos a tu solicitud dentro de los 10 días hábiles establecidos por la normativa argentina.
          </p>

          <h3 style={styles.subsectionTitle}>10.9 Reclamo ante la Autoridad</h3>
          <p style={styles.paragraph}>
            Si consideras que tus derechos han sido vulnerados, puedes presentar un reclamo ante la 
            <strong> Agencia de Acceso a la Información Pública (AAIP)</strong>, autoridad de control en 
            materia de protección de datos personales en Argentina.
          </p>
        </div>

        {/* International Transfers */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>11. Transferencias Internacionales</h2>
          <p style={styles.paragraph}>
            Algunos de nuestros proveedores de servicios pueden estar ubicados fuera de Argentina (por ejemplo, 
            servidores de hosting, servicios de Meta/WhatsApp). En estos casos, nos aseguramos de que existan 
            garantías adecuadas para la protección de tus datos, tales como:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Cláusulas contractuales estándar aprobadas</li>
            <li style={styles.listItem}>Certificaciones de privacidad reconocidas</li>
            <li style={styles.listItem}>Cumplimiento con estándares internacionales de protección de datos</li>
          </ul>
        </div>

        {/* Children Privacy */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>12. Privacidad de Menores</h2>
          <p style={styles.paragraph}>
            Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos intencionalmente información 
            personal de menores de edad. Si descubrimos que hemos recopilado datos de un menor sin el consentimiento 
            parental apropiado, eliminaremos esa información de inmediato.
          </p>
          <p style={styles.paragraph}>
            Si eres padre o tutor y crees que tu hijo nos ha proporcionado información personal, contáctanos 
            inmediatamente.
          </p>
        </div>

        {/* Changes to Policy */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>13. Cambios a esta Política de Privacidad</h2>
          <p style={styles.paragraph}>
            Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento para reflejar 
            cambios en nuestras prácticas, servicios o requisitos legales.
          </p>
          <p style={styles.paragraph}>
            Las modificaciones entrarán en vigor inmediatamente después de su publicación en el sitio web. 
            Te notificaremos sobre cambios significativos mediante:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Un aviso destacado en nuestro sitio web</li>
            <li style={styles.listItem}>Un correo electrónico a tu dirección registrada (si aplica)</li>
          </ul>
          <p style={styles.paragraph}>
            Te recomendamos revisar periódicamente esta política para estar al tanto de cualquier cambio.
          </p>
        </div>

        {/* Contact */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>14. Contacto</h2>
          <p style={styles.paragraph}>
            Si tienes preguntas, inquietudes o deseas ejercer tus derechos sobre tus datos personales, 
            puedes contactarnos:
          </p>
          <div style={styles.contactInfo}>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Sr Realty Group S.A.S.</strong>
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Email:</strong> <a href="mailto:info@tasacionesya.com" style={{ color: '#667eea' }}>info@tasacionesya.com</a>
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px' }}>
              <strong>Sitio web:</strong> <a href="https://tasacionesya.com" style={{ color: '#667eea' }}>www.tasacionesya.com</a>
            </p>
            <p style={{ margin: '5px 0', fontSize: '15px', marginTop: '10px' }}>
              <strong>Horario de atención:</strong> Lunes a Viernes, 9:00 - 18:00 hs (hora Argentina)
            </p>
          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={{ marginBottom: '10px' }}>
            <strong>Fecha de última actualización: 16 de enero de 2026</strong>
          </p>
          <p style={{ fontSize: '13px', marginTop: '15px' }}>
            © 2026 Tasacionesya.com - Sr Realty Group S.A.S. Todos los derechos reservados.
          </p>
          <p style={{ fontSize: '13px', marginTop: '10px' }}>
            <a href="/terminos-y-condiciones" style={{ color: '#667eea', marginRight: '15px' }}>Términos y Condiciones</a>
            <a href="/politica-de-privacidad" style={{ color: '#667eea' }}>Política de Privacidad</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
